<header class="orders-header has-border align-items-center d-flex pb-2 mb-4">
  <h1 class="m-0">CDI Disposition</h1>
  <h1 class="available-credit"></h1>
  <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
    <jni-spinner></jni-spinner>
  </div>
</header>

<header class="ordersummary-header adjustjustified">
  <div class="row">
    <div class="col-md-5">
      <div class="row actionselector">
        <div class="ordersummary-status ordersummary-col">
          Please select action
          <p-select
            class="p-0"
            [(ngModel)]="cdiActionVal"
            [options]="cdiAction"
            optionLabel="value"
            optionValue="name"
            [filter]="true"
            [showClear]="true">
          </p-select>
        </div>
        <!-- <div class="ordersummary-status ordersummary-col text-end">
            <button
              type="button"
              class="actionsubmitter"
              (click)="onCdiActionSubmit()"
            >
              Submit
            </button>
          </div> -->
      </div>
    </div>
  </div>
</header>

<div class="d-flex py-3 has-sticky justify-content-start">
  <button class="btn btn-secondary me-3" type="button" routerLink="/dashboard">
    Cancel
  </button>
  <button class="btn btn-primary" type="submit" (click)="onCdiActionSubmit()">
    Submit
  </button>
</div>

<h1 class="mb-2"><u>Order Summary</u></h1>
<div class="cdi-disposition">
  <p>
    <b>Client: </b><span>{{ clientName }}</span>
  </p>
  <p>
    <b>Order: </b><span>{{ orderNumber }}</span>
  </p>
  <p>
    <b>Job name: </b><span>{{ jobName }}</span>
  </p>
  <p>
    <b>Vendor: </b><span>{{ vendorName }}</span>
  </p>
</div>

<p style="color: red"><b>Reason: </b> {{ reason }}</p>

<div class="cdiresolutionsummary">
  <div class="row cdinotes">
    <div class="col-md-5">
      <div class="notesinner">
        <div class="title">AP Notes</div>
        <ul *ngFor="let note of cdiNotesGridListing">
          <li *ngIf="!!note.notesD365">{{ note.notesD365 }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
